// eslint-disable-next-line jira/restricted/react-component-props
import type { ComponentProps } from 'react';
import flow from 'lodash/flow';
import AnalyticsData from '@atlassian/jira-analytics-web-react/src/components/analytics-data.tsx';
import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import { SCREEN } from '@atlassian/jira-product-analytics-bridge';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { ANALYTIC_CONTEXTS } from '@atlassian/jira-servicedesk-common/src/utils/analytics/index.tsx';
import { getProjectKey } from '../../state/selectors/base/index.tsx';
import type { State } from '../../state/types.tsx';
import KnowledgeHubLoadingError from './view.tsx';

type KnowledgeHubLoadingErrorProps = JSX.LibraryManagedAttributes<
	typeof KnowledgeHubLoadingError,
	ComponentProps<typeof KnowledgeHubLoadingError>
>;
export type ConnectedKnowledgeHubLoadingErrorProps = Flow.Diff<
	KnowledgeHubLoadingErrorProps,
	{
		projectKey: KnowledgeHubLoadingErrorProps['projectKey'];
	}
>;

export default flow([
	AnalyticsData({
		attributes: {
			context: ANALYTIC_CONTEXTS.KNOWLEDGE,
		},
	}),
	AnalyticsSource('knowledgeLoadingError', SCREEN),
	connect(
		(state: State) => ({
			projectKey: getProjectKey(state),
		}),
		{},
	),
])(KnowledgeHubLoadingError);
